import React, { useState, useReducer, useEffect, useRef } from 'react';
import { Link, useParams } from "react-router-dom";
import { Button, Badge, Modal } from "react-bootstrap";
import idly from '../../../../images/items/idly.png';
import rice_img from '../../../../images/raw_material/rice.png';
import dhal_img from '../../../../images/raw_material/dhal.png';
import fenugreek_img from '../../../../images/raw_material/fenugreek.png';
import salt_img from '../../../../images/raw_material/salt.png';
import red_chilly_img from '../../../../images/raw_material/red_chilly.png';
import black_sesame_img from '../../../../images/raw_material/black_sesame.png';
import cumin_seeds_powder_img from '../../../../images/raw_material/cumin_seeds_powder.png';
import chana_dal_img from '../../../../images/raw_material/chana_dal.png';
import hing_img from '../../../../images/raw_material/hing.png';
import oil_img from '../../../../images/raw_material/oil.png';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css'; 
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';  
import lgZoom from 'lightgallery/plugins/zoom';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Divider } from '@mui/material';
import axios from 'axios'; // new
import bgimage from '../../../../images/items/items.jpg';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


const ViewItem = () => {
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const sno = queryParams.get('data');
    const navigate = useNavigate();

    const tableRef = useRef(null);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "paging": false,
                    scrollY: "200px", // Set the scroll height here
                    scrollCollapse: true,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                        // ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);
 
  const [item, setItem] = useState(null);
  const [stagings, setStagings] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/manage-items/${sno}`)
      .then(res => setItem(res.data.data))
      .catch(err => console.error(err));
  }, [sno]);

  useEffect(() => {
    if (!item) return;
    const saved = localStorage.getItem(`stagings_${item.sno}`);
    if (saved) {
      const parsed = JSON.parse(saved);
      // reorder item.item_staggings to match saved IDs
      const ordered = parsed.map(id =>
        item.item_staggings.find(s => s.item_stagging_id === id)
      ).filter(Boolean);
      setStagings(ordered);
    } else {
      setStagings(item.item_staggings || []);
    }
  }, [item]);

  const handleOnDragEnd = result => {
    if (!result.destination) return;
    const newArr = Array.from(stagings);
    const [moved] = newArr.splice(result.source.index, 1);
    newArr.splice(result.destination.index, 0, moved);
    setStagings(newArr);
    localStorage.setItem(`stagings_${item.sno}`,
      JSON.stringify(newArr.map(s => s.item_stagging_id)));
  };

  const formatDuration = str => {
    const [h, m] = str.split(' ');
    const hrs = parseInt(h) || 0, mins = parseInt(m) || 0;
    let res = [];
    if (hrs) res.push(`${hrs} hour${hrs > 1 ? 's' : ''}`);
    if (mins) res.push(`${mins} min${mins > 1 ? 's' : ''}`);
    return res.join(' ') || '0 min';
  };

  if (!item) return <div className="p-4">Loading...</div>;

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>View Items</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Package Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-items'>Manage Items</Link></li>
                    </ol>
                </div>
            </div>
            <div>
                <div className="row mb-3">
                    <div className="col-lg-12">
                        <div className="d-flex align-items-center justify-content-start gap-2">
                        
                            <LightGallery
                                onInit={onInit}
                                speed={500}
                                plugins={[lgThumbnail, lgZoom]}
                            >
                                <div data-src={item?.item_image || bgimage} className='border rounded px-1 py-0'>
                                    <img src={item?.item_image || bgimage} alt={item?.item_name} className='cursor-pointer w-90px h-90px' />
                                </div>
                            </LightGallery>
                        
                            <div>
                                <label className='text-black  fs-5'>
                                    <span>Item</span>
                                    <span className='me-2 ms-2'>-</span>
                                    <span >{item?.item_name || '-'}</span>
                                </label>
                                <label className='text-black me-3 ms-3'>|</label>
                                <label className='text-black font-w400 fs-5'>
                                    <span>Category</span>
                                    <span className='me-2 ms-2'>-</span>
                                    <span>{item?.itemcategory_name || '-'}</span></label>
                                <label className='text-black me-3 ms-3'>|</label>
                                <label className='text-black font-w400 fs-5'>
                                    <span>Sub Category</span>
                                    <span className='me-2 ms-2'>-</span>
                                    <span>{item?.itemsubcategory_name || '-'}</span></label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-7'>Quantity</label>
                                    <Badge bg="warning" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'> {item?.catering_corp_unit_slug_name || '-'}</Badge>
                                    <label className='text-black me-3 ms-3'>|</label>
                                    <label className='text-black font-w400 fs-7'>Weight</label>
                                    <Badge bg="success" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'> {item?.item_weight || '-'}</Badge>
                                    <label className='text-black me-3 ms-3'>|</label>
                                    <label className='text-black font-w400 fs-7'>Size</label>
                                    <Badge bg="info" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>{item?.item_size || '-'}</Badge>
                                </div>
                            </div>
                              
                        </div>
                    </div>
                </div>
                <div className='row mb-2'>
                    <div class="col-12 text-black fs-6">Description</div>
                    <div class="col-12 text-black fs-7">&emsp;&emsp; {item?.description || '-'}</div>
                </div>
                <div className='row mt-4'>
                    <div className='col-lg-12 mb-2'>
                        <label className='text-red font-w600 fs-4 mb-3'>Raw Material</label>
                        <label className='text-black fs-3 fw-bold ms-3 me-3 mb-2'>-</label>
                        <Badge bg="warning" className='text-black fs-4 py-0 px-1'>{item?.raw_material_count || '-'}</Badge>
                    </div>
                    {item?.raw_material?.length > 0 && (
                        <div className='row scroll-y mh-250px mb-4'>
                            {item.raw_material.map((raw, index) => (
                            <div className='col-lg-3 mb-2  pe-1'  key={index}>
                                <div className="border rounded px-1 py-1 d-flex align-items-center justify-content-start gap-3">
                                    <LightGallery
                                        onInit={onInit}
                                        speed={500}
                                        plugins={[lgThumbnail, lgZoom]}
                                    >
                                        {raw.image_url && (
                                        <div data-src={raw.image_url} className='rounded px-1 py-0'>
                                            <img src={raw.image_url} alt={raw.raw_material_name} className='cursor-pointer w-60px h-60px' />
                                        </div>
                                         )}
                                    </LightGallery>
                                    <div className="d-flex flex-column">
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Ponni Rice</span></Tooltip>} >
                                            <label className='text-primary font-w500 fs-6 text-truncate w-150px'>{raw.raw_material_name}</label>
                                        </OverlayTrigger>
                                        <label className='text-black font-w400 fs-7'>Grains</label>
                                        <label className='text-dark font-w400 fs-8'> {raw.quantity} {raw.unit_name}</label>
                                    </div>
                                </div>
                            </div> 
                             ))}
                        </div>
                     )}    
                </div>
                <div className='row'>
        

                   <div className='col-lg-8'>
                        <label className='text-red fs-4 font-w600 mb-4'>Recipe Notes</label>
                        <div className='recipe-notes-timeline px-3 py-2'>
                            <div className='scroll-y mh-300px px-3'>
                                {item?.receipe_notes?.process?.length > 0 ? (
                                    item.receipe_notes.process.map((step, index) => (
                                        <div className='d-flex mb-2' key={index}>
                                            <div className='timeline-marker d-flex flex-column align-items-center'>
                                                <div className='circle mt-3'></div>
                                            </div>
                                            <div className='timeline-content ms-4'>
                                                <label className='text-info font-w500 fs-5 mb-2'>
                                                    Step {index + 1} - {step.preparation_category_name}
                                                </label>
                                                <ul className='mb-2 row'>
                                                    {step.raw_materials?.map((rm, idx) => (
                                                        <li className='col-lg-5 text-black fs-6 mt-2' key={idx}>
                                                            <i className="far fa-circle-check text-primary fs-4 me-2"></i>
                                                            <span>{rm.raw_material_name} - {rm.quantity} {rm.unit_name}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                                <p className='text-black fs-7 mt-4'>{step.description}</p>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className='text-muted fs-6'>No recipe notes available.</div>
                                )}
                            </div>
                        </div>
                    </div>

                    
                    <div className='col-lg-4'>
                        <label className='text-red fs-4 font-w600 mb-4'>Item Quality List</label>
                        <div className='p-0 card'>
                            <ul className='mb-2 d-flex flex-column gap-3'>
                                {item?.item_quality?.length > 0 ? (
                                    item.item_quality.map((quality, index) => (
                                        <React.Fragment key={index}>
                                            <li className='text-black fs-6 px-4 pt-3 d-flex align-items-start'>
                                                <i className="fas fa-dot-circle text-primary fs-4 me-3 mt-1"></i>
                                                <div>
                                                    <div className='fw-bold'>{quality.quality_name}</div>
                                                    <div className='text-muted small'>Priority: {quality.priority_name}</div>
                                                </div>
                                            </li>
                                            <Divider className="m-0" />
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <li className='text-muted fs-6 px-4 pt-3'>No quality parameters available.</li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
   
     <div className='row mt-5 mx-2'>
        <label className='text-red fs-4 font-w600 mb-4'>Item Staging</label>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="staging" direction="horizontal">
            {provided => (
              <div
                className='d-flex gap-4 flex-wrap'
                style={{
                  display: 'inline-flex', border: '1px solid #1FBF75',
                  borderRadius: 4, padding: 10, backgroundColor: '#fff',
                  width: 'auto', maxWidth: '100%',
                }}
                ref={provided.innerRef} {...provided.droppableProps}
              >
                {stagings.map((stage, idx) => (
                  <Draggable
                    key={stage.item_stagging_id}
                    draggableId={String(stage.item_stagging_id)} index={idx}
                  >
                    {prov => (
                      <div
                        ref={prov.innerRef}
                        {...prov.draggableProps}
                        {...prov.dragHandleProps}
                        className='p-3 mb-3'
                        style={{
                          width: 400, border: '1px solid #80CFA9',
                          borderRadius: 4, backgroundColor: '#e7f6ee',
                          ...prov.draggableProps.style,
                        }}
                      >
                        <div className='d-flex justify-content-between mb-2'>
                          <div>
                            <label className='text-primary fs-6 font-w600'>{stage.item_stagging_name}</label>
                            <label className='text-black fs-7 d-block font-w400'>{stage.description || '-'}</label>
                          </div>
                          <div>
                            <i className='far fa-clock text-danger fs-7'></i>
                            <span className='text-danger fs-8 ms-2 fw-bold'>
                              {formatDuration(stage.work_duration)}
                            </span>
                          </div>
                        </div>
                        {stage.schedules?.length > 0 && (
                          <div className='pt-3'>
                            {stage.schedules.map((s, i) => (
                              <div key={i} className='border rounded px-3 py-2 mb-2 bg-white'>
                                <div className='d-flex justify-content-between mb-1'>
                                  <span className='fw-bold text-dark fs-8'>{s.schedule_name}</span>
                                  <span className='text-black fs-8'>
                                    {dayjs(s.start_time, 'HH:mm:ss').format('h:mm A')} -{' '}
                                    {dayjs(s.end_time, 'HH:mm:ss').format('h:mm A')}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

            </div>
        </>

    );
};

export default ViewItem;
